import React, {useEffect} from "react";
import "../CoursePage.sass"

export default function Mental() {
    useEffect(() => {
        document.title = 'КьюАй - Ментальная арифметика';
    }, [])

    return <>
        <div>
            Ментальная арифметика в центре детского развития КьюАй - это уникальная возможность для ребенка
            развить свои способности к быстрым вычислениям и повысить концентрацию внимания. Наши
            профессиональные преподаватели подберут индивидуальный подход к каждому ученику, а интересный
            материал поможет развить творческое и логическое мышление, а также креативные способности и
            наблюдательность. Обучение в КьюАй - это не только улучшение знаний в математике, но и возможность
            для ребенка стать более уверенным и самостоятельным.
        </div>
        <div className="course-footer-second">
            <div className="course-footer-second-ul">
                <div className="course-footer-second-ul-title">
                    Что получит ребёнок?
                </div>
                <ul>
                    <li>Развитие способности быстрых вычислений в уме;</li>
                    <li>Повышение концентрации внимания;</li>
                    <li>Улучшение фотопамяти;</li>
                    <li>Развитие творческого мышления;</li>
                    <li>Развитие логического мышления;</li>
                    <li>Развитие креативных способностей;</li>
                    <li>Повышение наблюдательности.</li>
                </ul>
            </div>
            <div className="course-footer-second-img">
                <div className="course-footer-second-ma"></div>
            </div>
        </div>
        <div>
            Наш центр детского развития КьюАй может сказать с гордостью, что в течение нескольких лет обучения
            курсу Ментальная арифметика мы добились значительных результатов. Среди наших учеников – множество
            олимпиадных призеров. Мы подготовили к участию в международных соревнованиях по Ментальной
            арифметике множество мальчиков и девочек. Наши ученики умные и талантливые ребята, которые
            выделяются отличными знаниями не только в математике. Обучение Ментальной арифметике также помогает
            в развитии навыков и в гуманитарных науках. Наши ученики и их родители довольны качеством обучения,
            что подтверждается множеством положительных отзывов.
        </div>
        <div className="course-footer-fourth">
            <div className="course-footer-fourth-img">
                <iframe width="100%" height="100%" src="https://www.youtube.com/embed/yNnqbFReJ2Q"
                        title="7-летний могилевчанин -  бронзовый призер по ментальной арифметике [БЕЛАРУСЬ 4| Могилев]"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen></iframe>
            </div>
        </div>
        <div>
            Результаты нашей школы за время преподавания курса Ментальная арифметика говорят сами за себя. Наши
            ученики успешно справляются с задачами и получают отличные оценки. Не упустите шанс повысить свой
            интеллект и развить свои способности с помощью курса Ментальная арифметика.
        </div>
    </>
}